import React, { useRef, useState, useEffect, useContext } from "react";
import "../styles/styles.css";
import "../../../styles/global.css";
import { icons } from "../../../constants";
import { uploadAndValidateImage, resolveErrorMessage } from "../../../utils/methods";
import AccreditationButton from "../../AccreditationButton/AccreditationButton";
import { TranslationsContext } from "../../../utils/TranslationsContext";

const AddPicture = ({
  setImageLoading,
  setImagePreview,
  imagePreview,
  setInputValue,
  route,
  pdf,
  disabled,
  getUploadHeaders,
}) => {
  const fileInputRef = useRef(null);
  const [pdfUrl, setPdfUrl] = useState(imagePreview);
  const { t } = useContext(TranslationsContext);

  const isPdfMode = !route && !!pdf;
  const isDisabled = disabled ?? false;

  const handleImageChange = async (e) => {
    if (isDisabled) return;

    const file = e.target.files[0];

    // PDF upload (nema route)
    if (file && !route) {
      const reader = new FileReader();
      reader.onload = async () => {
        const base64String = reader.result;

        setInputValue(base64String);
        setImagePreview && setImagePreview(base64String);

        const pdfBlob = base64ToBlob(base64String, "application/pdf");
        const pdfObjectUrl = URL.createObjectURL(pdfBlob);
        setPdfUrl(pdfObjectUrl);
      };

      reader.readAsDataURL(file);
      return;
    }

    // Image upload (ima route)
    if (file) {
      e.target.value = "";
      setImageLoading(true);

      try {
        const extraHeaders = getUploadHeaders ? await getUploadHeaders() : {};
        const response = await uploadAndValidateImage(route, file, extraHeaders);

        if (response && !response.error) {
          setImagePreview && setImagePreview(response?.file);
          setInputValue(response?.image);
          setPdfUrl(null); // nije PDF
        } else {
          alert(resolveErrorMessage(response, t));
        }
      } catch (error) {
        alert(
          "Došlo je do greške prilikom uploadovanja slike. Pokušajte ponovo."
        );
      } finally {
        setImageLoading(false);
      }
    }
  };

  const base64ToBlob = (base64Data, contentType = "application/pdf") => {
    const byteCharacters = atob(base64Data.split(",")[1]);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    return new Blob([byteArray], { type: contentType });
  };

  useEffect(() => {
    if (
      !route &&
      imagePreview &&
      imagePreview.startsWith("data:application/pdf")
    ) {
      const pdfBlob = base64ToBlob(imagePreview, "application/pdf");
      const pdfObjectUrl = URL.createObjectURL(pdfBlob);
      setPdfUrl(pdfObjectUrl);
    } else if (!route) {
      setPdfUrl(null);
    }
  }, [imagePreview, route]);

  return (
    <div className="flex-direction-column items-center width-100">
      <input
        ref={fileInputRef}
        type="file"
        accept={!route ? ".pdf" : ".jpg, .jpeg, .png, .bmp"}
        className="modal-input"
        onChange={handleImageChange}
        style={{ display: "none" }}
        disabled={isDisabled} // ⛔ disable input u PDF modu
      />

      <div
        className={`flex-direction-row items-center pointer justify-center add-picture-container${pdf ? " add-picture-container-pdf" : ""}`}
        onClick={() => {
          if (isDisabled) return; // ⛔ blokiraj klik
          fileInputRef.current && fileInputRef.current.click();
        }}
        aria-disabled={isDisabled}
        style={isDisabled ? { cursor: "not-allowed" } : undefined}
      >
        {pdfUrl && pdf ? (
          <iframe
            src={pdfUrl}
            title="PDF Preview"
            style={{ width: "100%", height: "100%", border: "none" }}
          />
        ) : (
          <img
            src={imagePreview ? imagePreview : icons.upload_img}
            alt="upload_img"
            className="add-picture-container-img"
          />
        )}
      </div>

      {pdf && pdfUrl && (
        <AccreditationButton
          type="save"
          title={t("CHANGE")}
          className="pdf-change"
          disabled={isDisabled}
          onClick={
            isDisabled
              ? undefined
              : () => fileInputRef.current && fileInputRef.current.click()
          }
        />
      )}
    </div>
  );
};

export default AddPicture;
